import authService from 'app/services/authService';
import { closeBackdrop, openBackdrop, resetNavigation, showMessage } from 'app/store/actions';
import * as UserActions from './user.actions';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

/* eslint-disable camelcase */

export function submitLogin({ email, password }) {
  return async (dispatch) => {
    dispatch(openBackdrop());
    try {
      const user = await authService.signInWithEmailAndPassword(email, password);
      dispatch(
        UserActions.setUserData({
          role: user?.realm_access?.roles,
          data: {
            displayName: [user?.name],
            email: [email],
            photoURL: undefined,
            settings: {},
            shortcuts: [],
          },
        })
      );

      dispatch(resetNavigation());

      dispatch(closeBackdrop());

      return dispatch({
        type: LOGIN_SUCCESS,
      });
    } catch (err) {
      dispatch(closeBackdrop());
      return dispatch(
        showMessage({
          message: err?.data?.message || 'E-mail ou senha inválidos',
          variant: 'error',
        })
      );
    }
  };
}
